import { render, staticRenderFns } from "./modalReagendarOs.vue?vue&type=template&id=a2052828&scoped=true"
import script from "./modalReagendarOs.vue?vue&type=script&lang=js"
export * from "./modalReagendarOs.vue?vue&type=script&lang=js"
import style0 from "./modalReagendarOs.vue?vue&type=style&index=0&id=a2052828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2052828",
  null
  
)

export default component.exports